import { Stack } from '@mui/material'
import type { PropsWithChildren, ReactNode } from 'react'

import { Label } from './Label'
import { Value } from './Value'

interface Props {
  label: ReactNode
  labelEndAdornment?: ReactNode
  color?: string
  testId?: string
  variant?: 'default' | 'alternative'
}

export function Field(props: PropsWithChildren<Props>) {
  const {
    label,
    children,
    color,
    labelEndAdornment,
    testId = 'rm-viewField-root',
    variant = 'default',
  } = props

  return (
    <Stack spacing={1} data-testid={testId}>
      {label && <Label endAdornment={labelEndAdornment}>{label}</Label>}
      <Value color={color} variant={variant}>
        {children}
      </Value>
    </Stack>
  )
}
